const ua = navigator.userAgent || '';

export const IS_IOS = /iphone|ipad|ipod/i.test(ua);
export const IS_ANDROID = /android/i.test(ua);
export const IS_WECHAT = /micromessenger\/([\d.]+)/i.test(ua);
export const IS_WEIBO = /(weibo).*weibo__([\d.]+)/i.test(ua);
export const IS_BAIDU = /(baiduboxapp)\/([\d.]+)/i.test(ua);
export const IS_QQ = /qq\/([\d.]+)/i.test(ua);
export const IS_QQBROWSER = /(qqbrowser)\/([\d.]+)/i.test(ua);